import { defineStore } from 'pinia';
import {userStoreActions, userStoreGetters} from '@/shared/helpers/userStoreHelper.js';

export const useUserStore = defineStore('user', {
	state: () => ({
		user: null,
		businesses: null,
		currBusinessId: null,
	}),
	getters: {
		currBusiness: state => {
			return userStoreGetters.currBusiness(state);
		},
		currPermissions: state => {
			return userStoreGetters.currPermissions(state);
		},
	},
	actions: {
		init(redirectUrlAuth = null, kickIfNotLogged = true) {
			userStoreActions.init(this, redirectUrlAuth, kickIfNotLogged);
		},
		normalizeBusiness(business) {
			return userStoreActions.normalizeBusiness(business);
		},
		normalizeAddress(address) {
			return userStoreActions.normalizeAddress(address);
		},
		refreshUserAccount(callback = null) {
			userStoreActions.refreshUserAccount(this, callback);
		},
		refreshBusiness(businessId, callback = null) {
			userStoreActions.refreshBusiness(this, businessId, callback);
		},
		getBusinessUsers(callback = null) {
			userStoreActions.getBusinessUsers(this, callback);
		},
		getBusinessLocation(callback = null) {
			userStoreActions.getBusinessLocation(this, callback);
		}
	},
});
